<template>
    <div v-if="state" class="py-12 transition duration-150 ease-in-out z-10 absolute top-0 right-0 bottom-0 left-0" id="modal">
        <div role="alert" class="mx-auto w-11/12 md:w-2/3 max-w-lg">
            <div class="relative p-5 bg-white shadow-md rounded-lg border border-gray-400">
                <div class="py-3"><slot /></div>
                <div
                    class="cursor-pointer absolute top-0 right-0 mt-4 mr-5 text-gray-400 hover:text-gray-600 transition duration-150 ease-in-out"
                    @click.prevent="close"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-label="Close"
                        class="icon icon-tabler icon-tabler-x"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        stroke-width="2.5"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" />
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'model',
    data() {
        return {
            state: false,
        };
    },
    props: {
        show: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    watch: {
        show(value) {
            this.state = value;
        },
    },

    methods: {
        close() {
            this.$emit('close');
        },
    },
};
</script>
